<app-indicator-filter></app-indicator-filter>
<p-divider></p-divider>
@if (indicatorStore.count() && categoryStore.count()) {
  <p-pickList
    class="app-pick-list"
    [source]="sourceList()"
    [target]="targetList()"
    [dragdrop]="true"
    [responsive]="true"
    [showSourceControls]="false"
    [showTargetControls]="false"
    (onMoveToSource)="removeFromSelection($event)"
    (onMoveToTarget)="addToSelection($event)"
    (onMoveAllToTarget)="addToSelection($event, true)"
    (onMoveAllToSource)="removeFromSelection($event)"
    [sourceStyle]="{ height: '25rem' }"
    [targetStyle]="{ height: '25rem' }"
    breakpoint="1400px">
    <ng-template pTemplate="sourceHeader">
      <app-pick-list-header title="Indikatoren" [count]="sourceList().length" />
    </ng-template>

    <ng-template pTemplate="targetHeader">
      <app-pick-list-header
        title="Auswahl"
        [count]="selectionLabel()"
        [subtitle]="targetHeaderSubtitle">
        @if (hiddenSelectionCount(); as hidden) {
          <span
            end
            pTooltip="Durch den Filter ausgeblendet, bleiben aber ausgewählt.">
            +{{ hidden }} ausgeblendet
          </span>
        }
        <div
          class="flex align-items-center gap-2 text-xs font-normal text-color-secondary mt-2">
          <i class="fas fa-circle-info"></i>
          <span>{{ ruleHint() }}</span>
        </div>
      </app-pick-list-header>
    </ng-template>

    <ng-template let-indicator pTemplate="item">
      @switch (rowKind(indicator)) {
        @case ('set') {
          <div
            class="pl-row pl-group"
            [ngClass]="{ 'pl-context': contextIds().has(indicator._id) }">
            <i class="fas fa-layer-group pl-icon"></i>
            <div class="pl-body">
              <span class="pl-name">{{ indicator.name }}</span>
              <ng-container
                *ngTemplateOutlet="meta; context: { $implicit: indicator }" />
            </div>
            @if (contextIds().has(indicator._id)) {
              <span
                class="pl-pill pl-pill-dashed"
                pTooltip="Passt selbst nicht zum Filter – wird nur als Gruppierung für passende Unterindikatoren angezeigt.">
                nur Gruppierung
              </span>
            } @else {
              <span class="pl-pill">{{ childCount(indicator) }}</span>
            }
            <span class="pl-end">{{ unitLabel(indicator) }}</span>
          </div>
        }
        @case ('child') {
          <div class="pl-row pl-child">
            <div class="pl-body">
              <span class="pl-name">{{ indicator.name }}</span>
              <ng-container
                *ngTemplateOutlet="meta; context: { $implicit: indicator }" />
            </div>
            <span class="pl-end">{{ unitLabel(indicator) }}</span>
          </div>
        }
        @default {
          <div class="pl-row">
            <i class="fas fa-ruler-vertical pl-icon"></i>
            <div class="pl-body">
              <span class="pl-name">
                @if (indicator.parent) {
                  <span class="pl-prefix"
                    >{{ indicatorStore.getParentName(indicator) }}:</span
                  >
                }
                {{ indicator.name }}
              </span>
              <ng-container
                *ngTemplateOutlet="meta; context: { $implicit: indicator }" />
            </div>
            <span class="pl-end">{{ unitLabel(indicator) }}</span>
          </div>
        }
      }
    </ng-template>

    <ng-template pTemplate="emptymessagesource">
      <div class="pl-empty">Keine weiteren Indikatoren.</div>
    </ng-template>
    <ng-template pTemplate="emptyfiltermessagesource">
      <div class="pl-empty">Kein Indikator passt zum Filter.</div>
    </ng-template>
    <ng-template pTemplate="emptymessagetarget">
      <div class="pl-empty">
        Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen übernehmen.
      </div>
    </ng-template>
  </p-pickList>
}

<!-- Meta line: folder (children only if it differs from their set) and tags -->
<ng-template #meta let-indicator>
  @if (indicator.tags | tagSummary; as tags) {
    @if (showsFolder(indicator) || tags.shown) {
      <span class="pl-meta">
        @if (showsFolder(indicator)) {
          @if (hasCategory(indicator)) {
            <span class="pl-meta-item">
              <i class="fas fa-folder pl-meta-icon"></i>
              {{ categoryStore.getPathById(indicator.category) }}
            </span>
          } @else {
            <span
              class="pl-meta-item pl-error"
              [pTooltip]="missingCategoryHint">
              <i class="fas fa-circle-exclamation pl-meta-icon"></i>
              Kein Ordner zugeordnet
            </span>
          }
        }
        @if (tags.shown) {
          <span
            class="pl-meta-item"
            [pTooltip]="tags.rest ? tags.all : undefined">
            <i class="fas fa-tag pl-meta-icon"></i>
            {{ tags.shown }}
            @if (tags.rest) {
              +{{ tags.rest }}
            }
          </span>
        }
      </span>
    }
  }
</ng-template>
